import React from 'react';
import {Navigate} from "react-router-dom";

import {MAIN_ROUTES} from "../routing/main_routes";

const IsCleaner = (Component) => {
    // const [isTokenValid, setIsTokenValid] = useState(false);
    return (props) => {
        const token = JSON.parse(localStorage.getItem('token'));
        const tokenExpires = JSON.parse(localStorage.getItem('expires'));
        const isCleaner = !!JSON.parse(localStorage.getItem('isCleaner'));

        let isTokenValid = false;

        if ((tokenExpires?.iat < tokenExpires?.exp) && isCleaner) {
            isTokenValid = true;
        }

        if (token?.access && isTokenValid) {
            // If authenticated, render the original element
            return <Component {...props} />
        }

        // If not authenticated, redirect to the login page
        return <Navigate to={MAIN_ROUTES.LOGIN}/>
    };
}

export default IsCleaner;

